import Research from 'modules/website/components/Research/Research'
import React from 'react'

export default function ResearchView() {
  return (
    <Research/>
  )
}
